export default __webpack_public_path__ + "static/media/10.633c72ca.png";